import { render, staticRenderFns } from "./ActionsNavAdmin.vue?vue&type=template&id=9365d972&"
import script from "./ActionsNavAdmin.vue?vue&type=script&lang=js&"
export * from "./ActionsNavAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports